// extracted by mini-css-extract-plugin
export default {"number-format":"styles_number-format__eR6zQ"};